import { useRef } from 'react';

/**
 * Latches `true` the first time `open` becomes truthy and never flips back.
 *
 * Modal bodies are dynamically imported (DEV-6485), so they must not be
 * rendered until the modal is first opened — `next/dynamic` fetches a chunk
 * as soon as its component renders, so mounting a closed modal would pull
 * the whole thing into the page load and undo the split.
 *
 * Keeping it mounted after the first open is deliberate: the close animation
 * still needs a mounted tree to play out, and a reopen is then instant.
 *
 * `open` is deliberately a required boolean: an uncontrolled modal that omits
 * it would never flip the latch, so its body would never render at all.
 */
export const useHasBeenOpened = (open: boolean) => {
  const hasBeenOpened = useRef(false);

  if (open) {
    hasBeenOpened.current = true;
  }

  return hasBeenOpened.current;
};
